import React, { useEffect, useState } from "react";
import { FiUpload } from "react-icons/fi";
import "./Notification.css";
import useUserList from "../../hooks/useUserList";
import Pagination from "../../components/MiniComponents/Pagination";
import { sendNotification } from "../../api/notificationApi";
import toast from "react-hot-toast";

const initialFormState = {
  notificationType: "",
  userPreference: "",
  // gamePerformance: "",
  userIds: [],
  title: "",
  message: "",

  // file: null,
};

function Notification() {
  const [formData, setFormData] = useState(initialFormState);
  const [page, setPage] = useState(1);
  const limit = 10;

  const { fetchUserList, userList, loading, totalPages } = useUserList();

  const handleChange = (e) => {
    const { name, value, files } = e.target;

    setFormData({ ...formData, [name]: value });
    // if (name === "file") {
    //   setFormData({ ...formData, file: files[0] });
    // } else {
    //   setFormData({ ...formData, [name]: value });
    // }
  };

  useEffect(() => {
    if (formData.userPreference === "selectedUsers") {
      fetchUserList(page, limit);
    }
  }, [formData.userPreference, page]);

  const handleUserSelect = (userId) => {
    setFormData((prev) => {
      const alreadySelected = prev.userIds.includes(userId);

      return {
        ...prev,
        userIds: alreadySelected
          ? prev.userIds.filter((id) => id !== userId)
          : [...prev.userIds, userId],
      };
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (
      !formData.notificationType ||
      !formData.userPreference ||
      !formData.title ||
      !formData.message
    ) {
      toast.error("all fields are reuired.");
      return;
    }

    if (
      formData.userPreference === "selectedUsers" &&
      formData.userIds.length === 0
    ) {
      toast.error("Please select at least one user.");
      return;
    }

    console.log(formData);
    const payload = {
      audience: formData.userPreference,
      title: formData.title,
      body: formData.message,
    };

    if (formData.userPreference === "selectedUsers")
      payload.userIds = formData.userIds;
    console.log("send Notification Payload:", payload);
    try {
      const res = await sendNotification(payload);
      toast.success("Notification send successfully");
      setFormData(initialFormState);
      setPage(1);
      console.log("send notification resp:", res);
    } catch (error) {
      console.error("error on send notification:");
      toast.error("Failed to send notification.");
    }
  };

  return (
    <div className="noti-container">
      <div className="noti-header">
        <h3>Notification</h3>
        <p>Lets update your audience with latest announcement.</p>
      </div>
      <div className="noti-main">
        <div className="form-container">
          <form onSubmit={handleSubmit} className="notification-form">
            <h2 className="form-heading">Notification Type</h2>
            <select
              name="notificationType"
              value={formData.notificationType}
              onChange={handleChange}
              className="form-input"
              required
            >
              <option value="" disabled>
                Select Notification Type
              </option>
              <option value="promotion">Information/Update</option>
              <option value="announcement">Promotion/Offer</option>
            </select>

            {/* {formData.userPreference === "selected" && (
              <>
                <h2 className="form-heading">Game Performance</h2>
                <select
                  name="gamePerformance"
                  value={formData.gamePerformance}
                  onChange={handleChange}
                  className="form-input"
                  required
                >
                  <option value="" disabled>Select Game Performance</option>
                  <option value="high">All Games</option>
                  <option value="low">Selected Games</option>
                </select>
              </>
            )} */}

            <h2 className="form-heading">User Preference</h2>
            <select
              name="userPreference"
              value={formData.userPreference}
              onChange={handleChange}
              className="form-input"
              required
            >
              <option value="" disabled>
                Select User Type
              </option>
              <option value="all">All Users</option>
              <option value="selectedUsers">Selected Users</option>
            </select>

            {formData.userPreference === "selectedUsers" && (
              <div>
                <h2 className="form-heading">Select User</h2>
                <div className="user-list">
                  {loading ? (
                    <p>Loading...</p>
                  ) : userList.length > 0 ? (
                    <div>
                      {userList.map((user) => (
                        <label key={user._id} className="user-item">
                          <input
                            type="checkbox"
                            checked={formData.userIds.includes(user._id)}
                            onChange={() => handleUserSelect(user._id)}
                          />
                          <span>
                            {user.name} ({user.email})
                          </span>
                        </label>
                      ))}
                      {totalPages > 1 && (
                        <Pagination
                          currentPage={page}
                          totalPages={totalPages}
                          onPageChange={(p) => setPage(p)}
                        />
                      )}
                    </div>
                  ) : (
                    <p>No users found</p>
                  )}
                </div>
              </div>
            )}

            <h2 className="form-heading">Title</h2>
            <input
              type="text"
              name="title"
              placeholder="Enter Title"
              value={formData.title}
              onChange={handleChange}
              className="form-input"
              required
            />

            <h2 className="form-heading">Message</h2>
            <textarea
              name="message"
              placeholder="Enter Message"
              value={formData.message}
              onChange={handleChange}
              rows="4"
              className="form-textarea"
              required
            />

            {/* <h2 className="form-heading">Media (Optional)</h2>
            <label className="upload-box">
              <span>{formData.file ? formData.file.name : "Upload Media"}</span>
              <FiUpload size={18} />
              <input
                type="file"
                name="file"
                onChange={handleChange}
                className="hidden"
              />
            </label> */}

            {/* <p className="upload-note">Note: Upload media in 2:1 ratio</p>
            <p className="upload-note">Size should not exceed 5MB</p> */}

            <button type="submit" className="submit-b">
              Send
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}

export default Notification;
